import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

// Static product data
const products = [
    { id: 1, name: 'Product 1' },
    { id: 2, name: 'Product 2' },
    { id: 3, name: 'Product 3' },
    { id: 4, name: 'Product 4' },
    { id: 5, name: 'Product 5' },
    { id: 6, name: 'Product 6' },
    { id: 7, name: 'Product 7' },
    { id: 8, name: 'Product 8' },
    { id: 9, name: 'Product 9' },
    { id: 10, name: 'Product 10' },
    { id: 11, name: 'Product 11' },
    { id: 12, name: 'Product 12' },
    { id: 13, name: 'Product 13' },
    { id: 14, name: 'Product 14' },
    { id: 15, name: 'Product 15' },
    { id: 16, name: 'Product 16' },
    { id: 17, name: 'Product 17' },
    { id: 18, name: 'Product 18' },
    { id: 19, name: 'Product 19' },
    { id: 20, name: 'Product 20' },
];

const ProductsPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [currentProducts, setCurrentProducts] = useState([]);
    const productsPerPage = 5; // Number of products component and filter component in same component per page

    const location = useLocation();

    // Get the current page from the URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const page = parseInt(params.get('page')) || 1;
        setCurrentPage(page);
    }, [location.search]);

    // Calculate and set the current products component and filter component in same component to display
    useEffect(() => {
        const startIndex = (currentPage - 1) * productsPerPage;
        const endIndex = startIndex + productsPerPage;
        setCurrentProducts(products.slice(startIndex, endIndex));
    }, [currentPage]);

    const totalPages = Math.ceil(products.length / productsPerPage);

    return (
        <div>
            <h1>Products</h1>
            <ul>
                {currentProducts.map((product) => (
                    <li key={product.id}>{product.name}</li>
                ))}
            </ul>
            <Pagination totalPages={totalPages} currentPage={currentPage} />
        </div>
    );
};

const Pagination = ({ totalPages, currentPage }) => {
    const pages = [...Array(totalPages).keys()].map((num) => num + 1);

    return (
        <nav>
            <ul className="pagination">
                {pages.map((page) => (
                    <li key={page} className={page === currentPage ? 'active' : ''}>
                        <Link to={`?page=${page}`}>{page}</Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default ProductsPage;
